export default __webpack_public_path__ + "static/media/strip-logo.c5004080.png";